import React, { ReactNode, useMemo } from "react";
import { ThemesProvider } from "@glossy";
import { getDarkThemes } from "@glossy/theme/templates/dark";
import { getLightThemes } from "@glossy/theme/templates/light";
import { useCurrentUserTheme } from "@linkfluence/core/user/use-cases";
import { Mode } from "@linkfluence/models/mode";

export function AppContext({ children }: { children: ReactNode }) {
  const theme = useCurrentUserTheme();
  const appTheme = useMemo(
    () => (theme === Mode.Light ? getLightThemes() : getDarkThemes()),
    [theme]
  );
  return <ThemesProvider themes={appTheme}>{children}</ThemesProvider>;
}
